export default {
      id: "ic-gift-catalog-usage",
      viewBox: "0 0 20 18",
      url: "/" + "images/icons.3.109.2.svg#ic-gift-catalog-usage",
      toString: function () {
        return this.url;
      }
    }